import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../i18n';
import { useUnits } from '../context/UnitsContext';
import { DEFAULT_FORMAT_PREFS, setFormatPrefs } from '../lib/formatPrefs';

/**
 * Applies authenticated user preferences to i18n/units.
 * Language defaults to English; only changes when user selects it in Settings.
 */
export function PreferencesSync() {
  const { user } = useAuth();
  const { setLanguage } = useI18n();
  const { setUnitSystem, setCurrency, UNIT_SYSTEMS, CURRENCIES } = useUnits();

  useEffect(() => {
    if (!user) {
      let lang = DEFAULT_FORMAT_PREFS.language;
      try {
        const stored = localStorage.getItem('language');
        if (stored && ['en', 'es'].includes(stored)) lang = stored;
      } catch {
        /* ignore */
      }
      setLanguage(lang, { persist: false });
      setUnitSystem(UNIT_SYSTEMS.IMPERIAL, { persist: false });
      setCurrency(DEFAULT_FORMAT_PREFS.currency, { persist: false });
      setFormatPrefs({ ...DEFAULT_FORMAT_PREFS, language: lang });
      return;
    }

    const prefs = user.preferences || {};
    const lang = prefs.language && ['en', 'es'].includes(prefs.language) ? prefs.language : 'en';
    const units = prefs.unit_system === UNIT_SYSTEMS.METRIC ? UNIT_SYSTEMS.METRIC : UNIT_SYSTEMS.IMPERIAL;
    const curr = Object.values(CURRENCIES).includes(prefs.currency) ? prefs.currency : DEFAULT_FORMAT_PREFS.currency;

    setLanguage(lang, { persist: true });
    setUnitSystem(units, { persist: true });
    setCurrency(curr, { persist: true });
    setFormatPrefs({ language: lang, currency: curr });
  }, [
    user,
    user?.preferences?.language,
    user?.preferences?.currency,
    user?.preferences?.unit_system,
    setLanguage,
    setUnitSystem,
    setCurrency,
    UNIT_SYSTEMS,
    CURRENCIES,
  ]);

  return null;
}

export default PreferencesSync;
